(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDocumentTemplateList', function () {
            
            return {
                templateUrl: 'app/dashboard/document-template-list.tmpl.html',
                scope: {
                    label: '@',
                    configuration: '='
                },
                controller: ['$q', '$scope', '$location', 'DocumentTemplatesService', 'DocumentTemplate', 'NavigationAidService', 'DialogService', 'SystemService', function ($q, $scope, $location, DocumentTemplatesService, DocumentTemplate, NavigationAidService, DialogService, SystemService) {
                    var drvCtrl = this;
                    drvCtrl.allDocumentTemplatesSelected = false;
                    drvCtrl.templateCount = 0;
                    drvCtrl.currentPage = 1;
                    drvCtrl.searchFields = {};
                    drvCtrl.newDocumentTemplate = newDocumentTemplate;
                    drvCtrl.deleteDocumentTemplate = deleteDocumentTemplate;
                    drvCtrl.templatePreview = templatePreview;
                    drvCtrl.updateList = updateList;
                    drvCtrl.showFileLink = showFileLink;
                    drvCtrl.getFile = getFile;
                    drvCtrl.copyDocumentTemplates = copyDocumentTemplates;
                    drvCtrl.deleteDocumentTemplates = deleteDocumentTemplates;
                    drvCtrl.close = close;
                    drvCtrl.loadCount = loadCount;
                    drvCtrl.loading = false;
                    drvCtrl.error = null;
                    drvCtrl.showDeleted = false;
                    Object.defineProperty(drvCtrl, 'selectedDocumentTemplates', {
                        get: function () {
                            return _(drvCtrl.documentTemplates)
                                .filter('Selected')
                                .value();
                        }
                    });
                    Object.defineProperty(drvCtrl, 'titleText', { get: getTitleText });

                    activate();

                    function activate() {
                        drvCtrl.searchDelay = SystemService.getSearchDelay();

                        // Watch for update on generic search text, update list if it changes
                        $scope.$watch('drvCtrl.genericSearch', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                updateList();
                            }
                        });

                        $scope.$watch('drvCtrl.showDeleted', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                updateList();
                                loadCount();
                            }
                        });

                        updateList();
                        loadCount();
                    }

                    function updateList(newPage) {
                        if (updateList.currentPromise === undefined) {
                            updateList.currentPromise = null;
                        }
                        var genericSearch = "";

                        // Page size will be supplied if it exists
                        var pageSize = null;
                        var entityTemplateId = null;
                        if (!angular.isUndefined(drvCtrl.configuration) && !angular.isUndefined(drvCtrl.configuration.ListPageSize) && drvCtrl.configuration.ListPageSize !== null) {
                            pageSize = angular.copy(drvCtrl.configuration.ListPageSize);
                        }
                        if (!angular.isUndefined(drvCtrl.configuration.EntityTemplateId) && drvCtrl.configuration.EntityTemplateId !== null) {
                            entityTemplateId = angular.copy(drvCtrl.configuration.EntityTemplateId);
                        }

                        if (!angular.isUndefined(newPage)) {
                            drvCtrl.currentPage = newPage;
                        }

                        if (!angular.isUndefined(drvCtrl.genericSearch)) {
                            genericSearch = angular.copy(drvCtrl.genericSearch);
                        }

                        drvCtrl.loading = true;
                        var getPromise = DocumentTemplate.getDocumentTemplates(pageSize, drvCtrl.currentPage, genericSearch, entityTemplateId)
                            .then(getDocumentTemplatesOk, getDocumentTemplatesError)
                            .then(function () {
                                drvCtrl.loading = false;
                            });

                        updateList.currentPromise = getPromise;

                        return getPromise;

                        function getDocumentTemplatesOk(data) {
                            if (getPromise === updateList.currentPromise) {
                                drvCtrl.error = null;
                                drvCtrl.allDocumentTemplatesSelected = false;
                                drvCtrl.documentTemplates = data.DocumentTemplates;
                                drvCtrl.templateCount = data.TemplateCount;
                            }
                            else {
                                return $q.reject();
                            }
                        }

                        function getDocumentTemplatesError(response) {
                            if (getPromise === updateList.currentPromise) {
                                drvCtrl.error = response;
                            }
                            else {
                                return $q.reject();
                            }
                        }
                    }

                    function loadCount() {
                        return DocumentTemplatesService.count(drvCtrl.showDeleted)
                            .then(loadCountOk, loadCountError);

                        function loadCountOk(count) {
                            drvCtrl.totalCount = count;
                        }

                        function loadCountError(response) {
                        }
                    }

                    function deleteDocumentTemplate(documentTemplate) {
                        documentTemplate.delete()
                            .then(deleteDocumentTemplateOk, deleteDocumentTemplateError);

                        function deleteDocumentTemplateOk(success) {
                            drvCtrl.updateList();
                            drvCtrl.loadCount();
                        }

                        function deleteDocumentTemplateError(response) {
                            if (!_.isNil(response)) {
                                DialogService.error('Error deleting Document Template', response);
                            }
                        }
                    }

                    function templatePreview(documentTemplate) {
                        var preview = '';
                        preview = documentTemplate.data.Description;

                        return preview;
                    }

                    function showFileLink(documentTemplate) {
                        var result = false;

                        if (!angular.isUndefined(documentTemplate.data.Template) && documentTemplate.data.Template !== null && documentTemplate.data.Template !== '') {
                            result = true;
                        }

                        return result;
                    }

                    function getFile(documentTemplate) {
                        if (!angular.isUndefined(documentTemplate.data.Template) && documentTemplate.data.Template !== null && documentTemplate.data.Template !== '') {
                            DocumentTemplatesService.getDocumentFile(documentTemplate.data.Id)
                                .then(getDocumentFileOk)
                                .catch(getDocumentFileError);
                        }

                        function getDocumentFileOk(response) {
                            var fileName = response.headers('Content-Disposition').match(/filename[^;\n=]*=((['"]).*?\2|[^;\n]*)/)[1];
                            fileName = fileName.replace(/^"/, '');
                            fileName = fileName.replace(/"$/, '');

                            var blob = new Blob([response.data], { type: response.headers('Content-Type') });
                            saveAs(blob, fileName);
                        }

                        function getDocumentFileError(response) {
                            DialogService.error('Error retrieving Document Template file', response);
                        }
                    }

                    /**
                     * Redirects to the new document template route
                     */
                    function newDocumentTemplate() {
                        var url = '/documenttemplates/new';

                        if (!angular.isUndefined(drvCtrl.configuration.EntityTemplateId) && drvCtrl.configuration.EntityTemplateId !== null) {
                            url += '?entityTemplateId=' + drvCtrl.configuration.EntityTemplateId;
                        }

                        $location.url(url);
                    }

                    /**
                     * Ensure at least one document template is selected.
                     * Displays a dialog 'No document templates were selected' if no document templates are selected.
                     * @return {bool} true if at least one document template is selected, else false
                     */
                    function ensureDocumentTemplatesSelection() {
                        if (drvCtrl.selectedDocumentTemplates.length === 0) {
                            DialogService.alert('No Document Templates were selected');
                            return false;
                        } else {
                            return true;
                        }
                    }

                    /**
                     * Copy the document templates selected in the list.
                     */
                    function copyDocumentTemplates() {
                        var selectedDocumentTemplateIds = _.map(drvCtrl.selectedDocumentTemplates, 'data.Id');
                        var documentTemplateLabel = 'Document Template';
                        if (selectedDocumentTemplateIds.length > 1) {
                            documentTemplateLabel += 's';
                        }

                        if (ensureDocumentTemplatesSelection()) {
                            DialogService
                                .confirm('Copy the ' + selectedDocumentTemplateIds.length + ' selected ' + documentTemplateLabel + '?', 'Copy ' + documentTemplateLabel + ' confirm')
                                .then(copyDocumentTemplatesConfirmed);
                        }

                        function copyDocumentTemplatesConfirmed() {
                            DocumentTemplatesService.multiCopy(selectedDocumentTemplateIds)
                               .then(copyOk, copyError);
                        }

                        function copyOk() {
                            updateList();
                            loadCount();
                        }

                        function copyError(response) {
                            DialogService.error('Error copying ' + documentTemplateLabel, response);
                            updateList();
                        }
                    }

                    /**
                     * Delete the document templates selected in the list.
                     */
                    function deleteDocumentTemplates() {
                        var selectedDocumentTemplateIds = _.map(drvCtrl.selectedDocumentTemplates, 'data.Id');

                        if (ensureDocumentTemplatesSelection()) {
                            return DialogService.show({
                                locals: { documentTemplateIds: selectedDocumentTemplateIds },
                                controller: 'DeleteDocumentTemplateDialog',
                                controllerAs: 'vm',
                                templateUrl: 'app/documenttemplate/delete-document-template-dialog.tmpl.html'
                            })
                            .then(deleteDocumentTemplatesConfirmed);
                        }

                        function deleteDocumentTemplatesConfirmed() {
                            DocumentTemplatesService.multiDelete(selectedDocumentTemplateIds)
                                .then(deleteDocumentTemplatesOk, deleteDocumentTemplatesError);
                        }

                        function deleteDocumentTemplatesOk(success) {
                            updateList();
                            loadCount();
                        }

                        function deleteDocumentTemplatesError(response) {
                            DialogService.error('Error deleting ' + documentTemplateLabel, response);
                        }
                    }

                    /**
                     * When the view is 'closed' navigation to a previous page should occur.
                     */
                    function close() {
                        NavigationAidService.goBack();
                    }

                    /**
                     * Gets the view title
                     *
                     * @returns {string}
                     */
                    function getTitleText() {
                        var result = '';

                        if (drvCtrl.showDeleted === true) {
                            result += 'Deleted ';
                        }

                        result += 'Document Templates';

                        return result;
                    }
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    configuration: '=',
                    viewMode: '<?',
                    subViewMode: '<?'
                }
            };
        });
})();